module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_5750_Active@1x-7fc37457b57e9b833b7d686e3c833b40.png";